import { computed } from "vue";
import { EstadoEmpresaAgentesEnum } from "@/.shared/.api";
import type { ExtendedUserInfo } from "@/.shared/services/auth/authentication/extended-user-info";
import { useAuthentication } from "@services/auth";

/** Rutas accesibles con empresa de agentes en estado distinto a VALIDADA. */
export const rutasPermitidasEmpresaAgentesNoValidada = new Set<string>([
  "mis-datos",
  "soporte",
  "ticket",
  "not-authorized",
]);

export function isAccesoRestringidoPorEmpresaAgentesNoValidada(user: ExtendedUserInfo | null): boolean {
  if (!user?.idEmpresaAgentes) return false;
  if (!user.idEstadoEmpresaAgentes) return false;
  return user.idEstadoEmpresaAgentes !== EstadoEmpresaAgentesEnum.Validada;
}

export function useEmpresaAgentesPortalRestringido() {
  const auth = useAuthentication();
  const accesoRestringido = computed(() =>
    isAccesoRestringidoPorEmpresaAgentesNoValidada(auth.userInfo as ExtendedUserInfo | null)
  );
  return { accesoRestringido };
}
